import React, { useState, useEffect, useContext } from "react";
// import { useCart } from '../contexts/CartContext'; // Your existing cart context
import CartContext from "../../../context/CartContext/CartContext";

import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Divider,
  Chip,
  Badge,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  InputAdornment,
  Avatar,
  Tabs,
  Tab,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  Add,
  Remove,
  Delete,
  ShoppingCart,
  Receipt,
  ClearAll,
  Search,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  IonAlert,
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { removeOutline, add } from "ionicons/icons";
import {
  getBarInventory,
  getCategories,
  getProducts,
} from "../../../api/products/product";
import { createBarOrder, createOrder } from "../../../api/orders/orders";
import { formatToNaira } from "../../../common/utils_t";
import { getAllMembers } from "../../../api/users/user";
import { useQuery } from "react-query";

// Sample data

const StyledProductCard = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "lowStock",
})(({ theme, lowStock }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: lowStock ? "#cd5c5c" : "1px solid transparent",
  color: lowStock ? "#fff" : theme.palette.text.primary,
  cursor: "pointer",
  transition: "transform 0.2s",
  border: lowStock ? "1px solid #b22222" : "1px solid transparent",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: theme.shadows[4],
  },
}));

const POSPage = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const { items, totalAmount, addItem, removeItem, clearCart } =
    useContext(CartContext);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
    const [open, setOpen] = useState(false);
     const [selectedMember, setSelectedMember] = useState(null);
  const [memberId, setMemberId] = useState("");
   const [loading, setLoading] = useState<boolean>(false);



   const {
      data: members = [],
      isLoading,
      error: isError,
    } = useQuery("getMemberList", getAllMembers, {
      refetchOnWindowFocus: true,
      retry: true,
      onError: (error) => {
        console.error("Error fetching member data:", error);
      },
    });
    
  const filteredProducts = products?.filter((product) => {
    const matchesCategory = selectedCategory
      ? product.category === selectedCategory
      : true;
    const matchesSearch = product.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleAddToCart = (product: (typeof products)[0]) => {
    addItem({
      id: product.product_id,
      product_name: product.name,
      quantity: 1,
      price: product.price,
      available_quantity: product.qty,
      product_id: product.product_id,
    });
  };

  const fetchProducts = async () => {
    try {
      const [response1, response2] = await Promise.all([
        getBarInventory(),
        getCategories(),
      ]);

      // console.log([response1, response2])

      setProducts(response1.data);
      setCategories(response2.data);
    } catch (error) {
      console.error("Error fetching products and categories:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
    getAllMembers();
  }, []);

  const calculateTotal = () => {
    return items.reduce((total, item) => total + item.price * item.qty, 0);
  };
    const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [continueAnyway, setContinueAnyway] = useState(false);
const [mwalletBal,  setWalletBal] = useState("0");

  const onHandleCreateOrder = async () => {
    const saleData = {
      items: items,
      totalPrice: totalAmount,
      member_id: memberId,

    };

    setLoading(true);
    try {
      const response = await createBarOrder(saleData);
    console.log({response});
      clearCart();
      fetchProducts();
      setOpen(false)
    } catch (error) {
      console.log(error);
      if (error.response || error.response.status === 422) {
        // Set errors from Laravel validation response
        console.error(error.response.data.message);
      } else {
        console.error("An unexpected error occurred:", error);
      }
    }
  };

  
  const onHandleCreateOrderFake = async () => {
      setContinueAnyway(false);

     if (totalAmount > Number(mwalletBal) && !continueAnyway) {
    setShowConfirmModal(true);
    return;
  }else{

    onHandleCreateOrder();
  }
  }
  const cartItemRemoveHandler = (id) => {
    removeItem(id);
  };

  // const cartItemAddHandler = (item) => {
  //   addItem({ ...item, quantity: 1 });
  // };

  console.log({ products });

  const cartItemAddHandler = (item) => {
    const existingCartItem = items.find(
      (cartItem) => cartItem.product_id == item.product_id
    );
    console.log({ existingCartItem });
    if (existingCartItem && existingCartItem.quantity >= item.qty) {
      setShowAlert(true);
      setAlertMessage("You cannot add more. Stock limit reached!");
      return;
    }

    addItem({ ...item, quantity: 1 });
  };
  const handleClose = () => setOpen(false);

  return (
    <IonPage>
      <Dialog open={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
        <DialogTitle>Insufficient Wallet Balance</DialogTitle>
        <DialogContent>
          <Typography>
            Your wallet balance is currently insufficient to process this transaction.
            Do you wish to proceed anyway?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmModal(false)} color="error">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setContinueAnyway(true);
              setShowConfirmModal(false);
              onHandleCreateOrder(); // re-call after confirmation
            }}
            variant="contained"
            color="primary"
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Bar Orders</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <Box sx={{ height: "90vh", display: "flex", flexDirection: "column" }}>
          {/* Header */}
          {/* <Box sx={{ p: 2, bgcolor: "primary.main", color: "white" }}>
            <Typography variant="h4">Benin Club POS System</Typography>
          </Box> */}

          {/* Main Content */}
          <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
            {/* Product Selection Panel */}
            <Box sx={{ width: "70%", p: 2, overflow: "auto" }}>
              {/* Search and Categories */}
              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Search products..."
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Tabs
                value={selectedCategory}
                onChange={(e, newValue) => setSelectedCategory(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 2 }}
              >
                <Tab label="All" value={null} />
                {categories?.map((category, i) => (
                  <Tab
                    key={i}
                    label={category.name}
                    value={category.name}
                  />
                ))}
              </Tabs>

              {/* Product Grid */}
              <Grid container spacing={2}>
                {filteredProducts?.map((product, i) => (
                  <Grid item xs={6} sm={4} md={3} key={i}>
  <StyledProductCard  lowStock={product?.qty < 1}  onClick={() => handleAddToCart(product)}>                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          src={product.img_src}
                          alt={product.name}
                          sx={{ width: 80, height: 80, mb: 1 }}
                        />
                        <Typography variant="subtitle1" align="center">
                          {product.name}
                        </Typography>
                        <Typography variant="subtitle1" align="center">
                                                  Qty: {product?.qty}
                                                  {/* {product?.qty} */}
                                                </Typography>
                        <Typography variant="body2" color="">
                           {formatToNaira(product?.price)}
                        </Typography>
                      </Box>
                    </StyledProductCard>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Cart Panel */}
            <Box
              sx={{
                width: "30%",
                borderLeft: "1px solid #e0e0e0",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  bgcolor: "background.paper",
                  borderBottom: "1px solid #e0e0e0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6">
                  <Badge
                    badgeContent={items.length}
                    color="primary"
                    sx={{ mr: 1 }}
                  >
                    <ShoppingCart />
                  </Badge>
                  Current Order
                </Typography>
                <Button
                  size="small"
                  color="error"
                  startIcon={<ClearAll />}
                  onClick={clearCart}
                  disabled={items.length === 0}
                >
                  Clear
                </Button>
              </Box>

              <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
                {items.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <ShoppingCart
                      sx={{ fontSize: 48, color: "text.disabled", mb: 1 }}
                    />
                    <Typography variant="body1" color="text.secondary">
                      Your cart is empty
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Select products to add to order
                    </Typography>
                  </Box>
                ) : (
                  <List dense>
                    {items.map((item, i) => (
                      <ListItem key={i} sx={{ py: 1 }}>
                        <Avatar
                          src={item?.image}
                          alt={item.product_name}
                          sx={{ width: 40, height: 40, mr: 2 }}
                        />
                        <ListItemText
                          primary={item.product_name}
                          secondary={`${formatToNaira(item.price)} each`}
                        />
                        <ListItemSecondaryAction
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          {/* <div slot="end" className="quantity-controls"> */}
                          <IonButton
                            fill="clear"
                            size="small"
                            onClick={() =>
                              cartItemRemoveHandler(item.product_id)
                            }
                          >
                            <IonIcon slot="icon-only" icon={removeOutline} />
                          </IonButton>

                          <IonText>{item.quantity}</IonText>

                          <IonButton
                            fill="clear"
                            size="small"
                            onClick={() => cartItemAddHandler(item)}
                          >
                            <IonIcon slot="icon-only" icon={add} />
                          </IonButton>
                          {/* </div> */}
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>

              {/* Order Summary */}
              <Box
                sx={{
                  p: 2,
                  borderTop: "1px solid #e0e0e0",
                  bgcolor: "background.paper",
                }}
              >
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography>Subtotal:</Typography>
              <Typography>${calculateTotal().toFixed(2)}</Typography>
            </Box> */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography>Tax (8%):</Typography>
              <Typography>${(calculateTotal() * 0.08).toFixed(2)}</Typography>
            </Box> */}
                {/* <Divider sx={{ my: 1 }} /> */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1">Total:</Typography>
                  <Typography variant="subtitle1">
                    {formatToNaira(totalAmount)}
                  </Typography>
                </Box>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  // onClick={() =>  onClick={(() => setOpen(true))}()}
                   onClick={(() => setOpen(true))}
                  startIcon={<Receipt />}
                  sx={{ mt: 2 }}
                  disabled={items.length === 0}
                >
                  Process Payment
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>..Select Member to Make Order</DialogTitle>
        <DialogContent dividers>
    <Autocomplete
             options={members?.data || []}
             getOptionLabel={(option) =>
               `${option?.email + " : " || ''}${option?.firstName || ''} ${option?.middleName || ''} ${option?.lastName || ''}`.trim()
             }
             onInputChange={(e, value) => setMemberId(value)}
             onChange={(event, newValue) => {
               setSelectedMember(newValue);
               setLoading(false);
               setMemberId(newValue?.user_id || "");
               setWalletBal(newValue?.amount || "0");
             }}
             renderOption={(props, option) => (
               <li {...props} key={option.user_id}>
                 {`${option?.email + " : " || ''}${option?.firstName || ''} ${option?.middleName || ''} ${option?.lastName || ''}`.trim()}
               </li>
             )}
             renderInput={(params) => (
               <TextField
                 {...params}
                 label="Member ID"
                 fullWidth
                 margin="normal"
                 placeholder="Start typing to search member ID"
               />
  
            )}
          />  
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={onHandleCreateOrderFake} variant="contained" disabled={!memberId || loading}>
            Confirm & Make Order
          </Button>
        </DialogActions>
      </Dialog>

        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => setShowAlert(false)}
          header="Notice"
          message={alertMessage}
          buttons={["OK"]}
        />
      </IonContent>
    </IonPage>
  );
};

export default POSPage;
